module.exports = __webpack_public_path__ + "img/img.d0619824.png";